import { render, staticRenderFns } from "./MagicLinkCallback.vue?vue&type=template&id=4403ce26&scoped=true&"
import script from "./MagicLinkCallback.vue?vue&type=script&lang=js&"
export * from "./MagicLinkCallback.vue?vue&type=script&lang=js&"
import style0 from "./MagicLinkCallback.vue?vue&type=style&index=0&id=4403ce26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4403ce26",
  null
  
)

export default component.exports